import { useMutation } from 'react-query'
import apiService from '../services/api'
import { apiURL } from '../services/api/apiURL'

export const useRegisterBrand = () => {
  const registerBrand = async args => {
    return await apiService.post(apiURL.auth.registerBrand, args)
  }
  return useMutation(registerBrand, {
    onSuccess: () => {},
    onError: () => {}
  })
}
